<template>
    <section id="reservation-search" class="generic-wrapper">
        <form action="" id="reservation-form">
            <div class="input-wrapper">
                <label for="check-in">Check-in</label>
                <input type="text" id="check-in" name="check_in">
            </div>

            <div class="input-wrapper">
                <label for="check-out">Check-out</label>
                <input type="text" id="check-out" name="check_out">
            </div>

            <div class="input-wrapper">
                <label for="rooms">Habitaciones</label>
                <input type="number" id="rooms" name="rooms" v-model="rooms" max="10"
                       min="1">
            </div>

            <div class="room-distribution-wrapper">
                <RoomDistribution v-for="n in rooms">{{ n }}</RoomDistribution>
            </div>
            <button class="reservation-submit">Ver Disponibilidad</button>
        </form>

        <div id="results-wrapper">
            <h1 class="title">Resultados - {{ searchResults.length }}</h1>
            <RoomResult v-for="result in searchResults" :room="result"/>
        </div>
    </section>
</template>

<script>
    import RoomDistribution from "../components/RoomDistribution";
    import RoomResult from "../components/RoomResult";

    let check_in_picker;
    let check_out_picker;

    export default {
        name: "Availability",
        components: {RoomResult, RoomDistribution},
        data() {
            return {
                check_in: this.$route.query.check_in ? this.$route.query.check_in : '',
                check_out: this.$route.query.check_out ? this.$route.query.check_out : '',
                adults: 2,
                children: 0,
                rooms: 1,
                searchResults: [
                    {
                        room_title: 'Habitación Doble',
                        capacity: 4,
                        image: 'https://hotellashamacas.com/images/room_images/thumbnails/1421944758349.JPG',
                        price: 1150,
                        description: 'Incluye un desayuno, dos camas, agua caliente, WiFi y todos los extras'
                    },
                    {
                        room_title: 'Habitación Sencilla',
                        capacity: 2,
                        image: 'https://hotellashamacas.com/images/room_images/thumbnails/142306567988.JPG',
                        price: 850,
                        description: 'Incluye un desayuno, una cama, agua caliente, WiFi y todos los extras'
                    }
                ],
            }
        },
        watch: {
            rooms(newValue) {
                if (newValue > 0) {
                    this.rooms = parseInt(newValue);
                } else {
                    this.rooms = 1
                }
            }
        },
        mounted() {
            check_in_picker = new this.$pikaday({
                field: document.getElementById('check-in'),
                format: 'DD MMM YYYY',
                minDate: new Date(),
                i18n: this.$i18n_picker,
                onSelect: () => {
                    this.check_in = check_in_picker.toString('YYYY-MM-DD');
                }
            });
            check_in_picker.setDate(this.$moment().format());
            check_out_picker = new this.$pikaday({
                field: document.getElementById('check-out'),
                format: 'DD MMM YYYY',
                minDate: new Date(),
                i18n: this.$i18n_picker,
                onSelect: () => {
                    this.check_out = check_out_picker.toString('YYYY-MM-DD');
                }
            });
            check_out_picker.setDate(this.$moment().add(1, 'days').format())
        },
        methods: {
            redirectToSearch() {

            }
        }
    }
</script>

<style scoped>
    #reservation-search {
        min-height: auto;
        width: 100%;
    }

    #reservation-form {
        height: 100%;
        display: flex;
        justify-content: space-around;
        padding: 20px 0;
        align-items: flex-start;
    }

    #reservation-form .input-wrapper label {
        color: #643229;
    }

    #reservation-form .input-wrapper input {
        padding: 5px 5px 0 5px;
        font-size: 16px;
        display: block;
        width: 80%;
        box-sizing: border-box;
        border: 0;
        border-bottom: 1px solid #666;
    }

    #reservation-form .input-wrapper input:focus {
        outline: 0;
    }

    #reservation-form .reservation-submit {
        padding: 15px;
        background-color: #643229;
        color: #F1DDC4;
        font-size: 16px;
        font-weight: 500;
    }

    #results-wrapper {
        padding: 15px 5px 5px 5px;
    }

    #results-wrapper .title {
        font-size: 2rem;
        font-weight: 500;
        text-align: center;
        padding: 0;
        margin: 0;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        #reservation-form {
            flex-direction: column;
            padding: 10px;
            align-items: center;
        }

        #reservation-form .input-wrapper {
            margin-top: 15px;
            width: 100%;
        }

        #reservation-form .room-distribution-wrapper {
            margin-top: 20px;

        }

        #reservation-form .reservation-submit {
            margin-top: 10px;
            align-self: stretch;
        }

    }
</style>